/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const GET_INVOICE_REPORTS_BY_MFG = 'GET_INVOICE_REPORTS_BY_MFG';
export const GET_DISP_INVOICE_DETAILS_BY_INVOICE_NUM =
  'GET_DISP_INVOICE_DETAILS_BY_INVOICE_NUM';
export const GET_HANDLING_CODE = 'GET_HANDLING_CODE';
export const GET_INVOICE_QUARTER = 'GET_INVOICE_QUARTER';
export const GET_INVOICE_CODE = 'GET_INVOICE_CODE';
export const GET_INVOICE_OTHER_QUARTER = 'GET_INVOICE_OTHER_QUARTER';
export const GET_INVOICE_QUARTER_TOTALS = 'GET_INVOICE_QUARTER_TOTALS';
export const GET_ALL_REBATE_PROGRAMS = 'GET_ALL_REBATE_PROGRAMS';
export const SAVED_INVOICE_DETAILS = 'SAVED_INVOICE_DETAILS';
export const GET_DRUG_ACTIVITY = 'GET_DRUG_ACTIVITY';
export const GET_CHECK_LOG_BY_INVOICE_NUM = 'GET_CHECK_LOG_BY_INVOICE_NUM';
export const SET_DEFAULT_QTR = 'SET_INVOICE_REPORT_DEFAULT_QTR';
export const SET_ERROR_MESSAGES_INNVOICE_REPORT =
  'SET_ERROR_MESSAGES_INNVOICE_REPORT';
export const SET_ERRORS = 'SET_ERRORS';
export const RESET_DISPLAY_INVOICE_REPORT_STORE =
  'RESET_DISPLAY_INVOICE_REPORT_STORE';
export const SEARCH_INVOICE_REPORT_REQUEST = 'SEARCH_INVOICE_REPORT_REQUEST';
export const SET_INVOICE_REPORT_SELECTED_CLIENT =
  'SET_INVOICE_REPORT_SELECTED_CLIENT';
export const SET_INVOICE_REPORT_NUMBER = 'SET_INVOICE_REPORT_NUMBER';
export const SET_INVOICE_REPORT_NO_RECORD_FOUND =
  'SET_INVOICE_REPORT_NO_RECORD_FOUND';
export const INVOICE_LETTER_TABLE_DATA = 'INVOICE_LETTER_TABLE_DATA';
export const INVOICE_GET_PRINT_PREVIEW_DISPLAY =
  'INVOICE_GET_PRINT_PREVIEW_DISPLAY';
export const INVOICE_GET_REPORT_COVER_DISPLAY =
  'INVOICE_GET_REPORT_COVER_DISPLAY';
export const INVOICE_GET_REPORT_SECTION_ONE_DISPLAY =
  'INVOICE_GET_REPORT_SECTION_ONE_DISPLAY';
export const INVOICE_GET_REPORT_SECTION_TWO_DISPLAY =
  'INVOICE_GET_REPORT_SECTION_TWO_DISPLAY';
export const INVOICE_GET_REPORT_SECTION_THREE_DISPLAY =
  'INVOICE_GET_REPORT_SECTION_THREE_DISPLAY';
export const INVOICE_GET_UPDATE_DUPLICATEINVOICE =
  'INVOICE_GET_UPDATE_DUPLICATEINVOICE';
export const GET_SAVE_COVER_LETTER = 'GET_SAVE_COVER_LETTER';
export const GET_INV_GRID_FLAG = 'GET_INV_GRID_FLAG';
export const SET_IS_SEARCH_CLICKED = 'SET_IS_SEARCH_CLICKED';
